import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../../../context/commandsContext';
import useKeyPress from '../../../../../hooks/useKeyPress';
import {useMenu} from '../../../../../hooks/useMenu';
import BodyContentView from '../../../../views/bodyContentView';
import FlowInstallationFinished from './installation-finished';
import InstallationFlowPB from './installationFlowPB';

function FlowInstallationContinuation({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onComponent(<InstallationFlowPB />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Installation Verification"
      left="Abort"
      right="Continue"
      caption="Running Installation Verification can affect transmitter operation.  Control loop should be set for manual operation."
    />
  );
}

export default FlowInstallationContinuation;
